<template>
    <!-- Start Main Content -->
    <div class="form-container" v-if="invoice">
      <div class="form-header">
        <img src="logo.png" alt="Logo">
        <h2 class="form-title">Service Subscription</h2>
      </div>
    
      <div class="section">
        <div class="section-title">Contact Details</div>
        <div class="row">
          <div class="col-50">
            <div class="form-group">
              <label>Full Name:</label>
              <p>{{invoice.firstname2}} {{invoice.lastname}}</p>
            </div>
            <div class="form-group">
              <label>Date of Birth:</label>
              <p>{{invoice.dob}}</p>
            </div>
            <div class="form-group">
              <label>Gender:</label>
              <p>{{invoice.gender}}</p>
            </div>
            <div class="form-group">
              <label>Contact Number:</label>
              <p>{{invoice.phonenumber}}</p>
            </div>
          </div>
          <div class="col-50">
            <div class="form-group">
              <label>Membership ID:</label>
              <p></p>
            </div>
            <div class="form-group">
              <label>Email:</label>
              <p>{{invoice.email}}</p>
            </div>
            <div class="form-group">
              <label>Address:</label>
              <p>{{invoice.address}}</p>
            </div>
            <div class="form-group">
              <label>Adhar Card No.:</label>
              <p>{{invoice.aadharno}}</p>
            </div>
          </div>
        </div>
      </div>
    
      
    
    
      <div class="section">
        <div class="section-title">Service Subscription Details</div>
        <div class="form-group">
          <label>Service Name:</label>
          <p>{{invoice.name}}</p>
        </div>
        <div class="form-group">
          <label>Staff Name:</label>
          <p>{{invoice.firstname}}</p>
        </div>
        <div class="form-group">
          <label>From Date:</label>
          <p>{{invoice.from_date}}</p>
        </div>
        <div class="form-group">
          <label>To Date:</label>
          <p>{{invoice.to_date}}</p>
        </div>
        <div class="form-group">
          <label>Amount:</label>
          <p>{{invoice.total_amt}}</p>
        </div>
        <div class="form-group">
          <label>Paid:</label>
          <p>{{invoice.paid}}</p>
        </div>
        <div class="form-group">
          <label>Remaining Amount:</label>
          <p>{{invoice.total_amt - invoice.paid}}</p>
        </div>
      </div>
    
      
      
      <div class="footer">
        <p>&copy; FITRIUM GYM. All rights reserved.</p>
      </div>
    </div>


    


</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'AddProduct',
components: {
 
} ,
mounted(){
    const memberId = this.$route.query.id; // Retrieve the query parameter
    this.fetchInvoice(memberId);
},
data() {
 return {
     staffList:[],
     attendance: [],
    invoice:null,
 }
 }, 
methods:{
    fetchInvoice(memberId) {
      axios.post(`/invoice/subscriptiondetails/${memberId}`)
        .then(response => {
          this.invoice = response.data;

          // Wait for DOM update and trigger print
          this.$nextTick(() => {
            window.print();
          });
        })
        .catch(error => {
          console.error('Error fetching invoice:', error);
        });
    },
  
  

            
}
}
</script>
<style scoped>
    * {
    box-sizing: border-box;
    font-family: Arial, sans-serif;
  }

  body {
    background-color: #f3f3f3;
    padding: 20px;
  }

  .form-container {
    width: 800px;
    margin: auto;
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 20px;
  }

  .form-header {
    text-align: center;
    margin-bottom: 20px;
  }

  .form-header img {
    width: 100px;
    margin-bottom: 10px;
  }

  .form-title {
    font-weight: bold;
    font-size: 24px;
    margin: 0;
  }

  .section {
    margin-bottom: 15px;
  }

  .section-title {
    font-weight: bold;
    font-size: 18px;
    background-color: #000;
    color: #fff;
    padding: 5px;
    margin-bottom: 10px;
  }

  .form-group {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .form-group label {
    flex: 0 0 200px;
    font-weight: bold;
  }

  .form-group input {
    flex: 1;
    padding: 5px;
    border: 1px solid #ddd;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
  }

  .col-50 {
    width: 50%;
    padding: 0 10px;
  }

  .col-100 {
    width: 100%;
  }

  .footer {
    text-align: center;
    margin-top: 20px;
  }
    </style>